import { v4 as uuid } from 'uuid'

export interface TCatalogBindingItem {
  key: string
  catalogId: string
  catalogItemId: string
  businessId: string
  entityId: string
  entityType: 'business'|'taxonomy'|'resource'|'appointment'
  data: {
    businessName?: string
    entityName?: string
    [keys: string]: any
  }
}

const initialData: TCatalogBindingItem = {
  key: '',
  catalogId: '',
  catalogItemId: '',
  businessId: '',
  entityId: '',
  entityType: 'business',
  data: {},
}

export const create = (data?: Partial<TCatalogBindingItem>): TCatalogBindingItem => ({
  ...initialData,
  key: uuid(),
  data: {},
  ...data,
})
